import ManagerListPage from './ManagerListPage';

export const ManagerListPageConfig = {
  routes: [
    {
      path: '/pages/manager',
      exact: true,
      component: ManagerListPage,
    },
  ],
};
